import identityGetPredicate from './identity.getPredicate';
import identityGetPhoneNumbers from './identity.getPhoneNumbers';
import identityGetEmail from './identity.getEmail';
import identityGetKbaRequestId from './identity.getKbaRequestId';
import identityGetKbaQuestions from './identity.getKbaQuestions';
import identityGetShowKbaStatus from './identity.getShowKba';
import identityGetStatus from './identity.getStatus';

export const getPredicate = identityGetPredicate;
export const getPhoneNumbers = identityGetPhoneNumbers;
export const getEmail = identityGetEmail;
export const getKbaRequestId = identityGetKbaRequestId;
export const getKbaQuestions = identityGetKbaQuestions;
export const getShowKbaStatus = identityGetShowKbaStatus;
export const getStatus = identityGetStatus;
